/* global bocAmchart4, am4core, am4maps, chartLanguage */

/**
 * Get colors for the map from the shortcode or define defaults
 * @param {object} chart object
 * @returns {void}
 */
bocAmchart4.getColorsFromShortcode = function (chart) {
    // Default values for minColor and maxColor
    let minColor = "#ddf";
    let maxColor = "#11f";

    // Override the default minColor value if defined in the shortcode
    if (chart.bocSettings.args.hasOwnProperty('mincolor')) {
        minColor = chart.bocSettings.args.mincolor;
    }

    // Override the default maxColor value if defined in the shortcode
    if (chart.bocSettings.args.hasOwnProperty('maxcolor')) {
        maxColor = chart.bocSettings.args.maxcolor;
    }

    // Push the first interval colour into mainColors so we can maintain the order when we render later on
    bocAmchart4.vars[chart.bocSettings.id].mainColors.push(am4core.color(minColor));

    // Push the middle interval colours to mainColors
    let midMore = true;
    let midIndex = 0;
    while (midMore) {
        if (chart.bocSettings.args.hasOwnProperty('midcolor' + midIndex)) {
            bocAmchart4.vars[chart.bocSettings.id].mainColors.push(
                am4core.color(chart.bocSettings.args['midcolor' + midIndex])
            );
            midIndex++;
        } else {
            midMore = false;
        }
    }

    // Push the last interval colour
    bocAmchart4.vars[chart.bocSettings.id].mainColors.push(am4core.color(maxColor));

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Defined main colors:",
            bocAmchart4.debugClone(bocAmchart4.vars[chart.bocSettings.id].mainColors)
        );
    }
};

/**
 * Set up buckets for the legend based on default datapoints or user-defined ranges
 * @param {object} chart object
 * @returns {void}
 */
bocAmchart4.getBucketsFromShortcode = function (chart) {
    // Default min and max values of the dataset with markerCount of 2
    let minValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].minValue);
    let maxValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].maxValue);
    let separateOverflow = false;
    let markerCount = 2;
    let minColorValue = false;
    let maxColorValue = false;

    // Round to however many decimals are in the dataset
    let decimalCount = 0;
    let minValueStr = String(minValue);
    if (minValueStr.includes('.')) {
        decimalCount = minValueStr.split('.')[1].length;
    }

    // Set up for overflow buckets (i.e. < minValue, >= maxValue)
    let minOverflowBucket = false;
    let maxOverflowBucket = false;
    let legendBuckets = [];

    if (chart.bocSettings.args.hasOwnProperty('separateoverflow') && chart.bocSettings.args.separateoverflow === "true") {
        separateOverflow = true;
    }

    // Override markerCount with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('markercount') && Number(chart.bocSettings.args.markercount) > 1) {
        markerCount = parseFloat(chart.bocSettings.args.markercount);
    }

    // Override maxColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('maxcolorvalue')) {
        maxColorValue = parseFloat(chart.bocSettings.args.maxcolorvalue);
        // Get the number of decimal points based on user defined value
        if (chart.bocSettings.args.maxcolorvalue.includes('.')) {
            decimalCount = chart.bocSettings.args.maxcolorvalue.split('.')[1].length;
        }
        maxOverflowBucket = separateOverflow;
    }

    // Override minColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('mincolorvalue')) {
        minColorValue = parseFloat(chart.bocSettings.args.mincolorvalue);
        // Get the number of decimal points based on user defined value.
        // If there are decimals in both max and minColorValue, it will use the minColorValue decimal points
        if (chart.bocSettings.args.mincolorvalue.includes('.')) {
            decimalCount = chart.bocSettings.args.mincolorvalue.split('.')[1].length;
        }
        minOverflowBucket = separateOverflow;
    }

    // Log error because it's impossible to render with overflow buckets and a markerCount of less than 3
    if (minOverflowBucket && maxOverflowBucket && markerCount < 3) {
        console.error("Marker count should be at least 3 when mincolorvalue, maxcolorvalue and separateOverflow are defined");
        return;
    }

    // User selected logarithmic legend
    if (chart.bocSettings.args.hasOwnProperty('logarithmic') && chart.bocSettings.args.logarithmic === 'true') {
        minValue = minColorValue ? minColorValue : minValue;
        maxValue = maxColorValue ? maxColorValue : maxValue;

        // Can't have min or max values of 0 as it will break the logarithmic calculations
        if (minValue === 0 || maxValue === 0 || (maxValue > 0 && minValue < 0)) {
            console.log(
                chart.bocSettings.id,
                "Can't allow logarithmic scale near 0, adjust the minimum or maximum value:",
                "Min value: " + minValue,
                "Max value: " + maxValue
            );
            return;
        }

        // Overflow for first interval
        legendBuckets.push(false);
        // Logarithmic intervals
        let expectedMidColorValues = markerCount - maxOverflowBucket - minOverflowBucket - 1;
        for (let index = 1; index < markerCount; index++) {
            let logValue = Math.exp(
                Math.log(minValue) + (Math.log(maxValue) - Math.log(minValue)) / (expectedMidColorValues + 1) * index
            );
            legendBuckets.push(parseFloat(logValue.toFixed(decimalCount)));
        }
        // Overflow for last interval
        legendBuckets.push(false);
    } else {
        if (minColorValue === false) {
            // Round to user-defined or dataset-defined number of decimals
            minValue = parseFloat(minValue.toFixed(decimalCount));
            // No user-defined minimum so push minValue
            legendBuckets.push(minValue);
        } else if (minOverflowBucket) {
            // Round to user-defined or dataset-defined number of decimals
            minColorValue = parseFloat(minColorValue.toFixed(decimalCount));
            // separateOverflow is true and user defined minColorValue so push that
            legendBuckets.push(false, minColorValue);
        } else {
            // separateOverflow is false but minColorValue is defined
            legendBuckets.push(false);
        }

        // Expected number of midcolors
        let expectedMidColorValues = markerCount - maxOverflowBucket - minOverflowBucket - 1;
        let midColorValues = [];

        // Set up for all the midColorValues, i.e. the boundaries between buckets
        if (chart.bocSettings.args.hasOwnProperty('midcolorvalue0')) {
            // If midColorValue exists, set up the buckets based on user-defined values
            let midMore = true;
            let midIndex = 0;
            let midColorValue;
            // Keep adding midColorValues as a bucket until there are none left
            while (midMore) {
                if (chart.bocSettings.args.hasOwnProperty('midcolorvalue' + midIndex)) {
                    midColorValue = parseFloat(chart.bocSettings.args['midcolorvalue' + midIndex]);
                    // Round to user-defined or dataset-defined number of decimals
                    midColorValues.push(parseFloat(midColorValue.toFixed(decimalCount)));
                    midIndex++;
                    // Stop adding midcolorvalues if we have enough
                    if (midIndex === expectedMidColorValues) {
                        midMore = false;
                    }
                } else {
                    midMore = false;
                }
            }
        }

        // If there aren't enough midColorValues, then switch to evenly distributed buckets
        if (midColorValues.length !== expectedMidColorValues) {
            midColorValues = [];
            minValue = minColorValue ? minColorValue : minValue;
            maxValue = maxColorValue ? maxColorValue : maxValue;

            // Separate buckets evenly based on expectedMidColorValues
            let difference = (maxValue - minValue) / (expectedMidColorValues + 1);
            let markerCountFlag = expectedMidColorValues;
            let currentValue = minValue;

            while (markerCountFlag > 0) {
                currentValue = currentValue + difference;
                // Round to user-defined or dataset-defined number of decimals
                midColorValues.push(parseFloat(currentValue.toFixed(decimalCount)));
                markerCountFlag--;
            }
        }
        legendBuckets = legendBuckets.concat(midColorValues);

        if (maxColorValue === false) {
            // Round to user-defined or dataset-defined number of decimals
            maxValue = parseFloat(maxValue.toFixed(decimalCount));
            // No user-defined maximum so push maxValue
            legendBuckets.push(maxValue);
        } else if (maxOverflowBucket) {
            // Round to user-defined or dataset-defined number of decimals
            maxColorValue = parseFloat(maxColorValue.toFixed(decimalCount));
            // separateOverflow is true and user defined maxColorValue so push that
            legendBuckets.push(maxColorValue, false);
        } else {
            // separateOverflow is false but maxColorValue is defined
            legendBuckets.push(false);
        }
    }

    // Store the legend intervals and decimal count
    bocAmchart4.vars[chart.bocSettings.id].legendBuckets = legendBuckets;
    bocAmchart4.vars[chart.bocSettings.id].decimalCount = decimalCount;

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Defined buckets:",
            bocAmchart4.debugClone(bocAmchart4.vars[chart.bocSettings.id].legendBuckets)
        );
    }
};

/**
 * Formats the given number based on the chart's locale and decimal count
 * @param {object} chart object
 * @param {number} value number to be formatted
 * @returns {string} formatted number as a string
 */
bocAmchart4.locale = function (chart, value) {
    return value.toLocaleString(
        bocAmchart4.vars[chart.bocSettings.id].locale, {
            minimumFractionDigits: bocAmchart4.vars[chart.bocSettings.id].decimalCount,
            maximumFractionDigits: bocAmchart4.vars[chart.bocSettings.id].decimalCount
        }
    );
};

/**
 * Get colors for the map from the shortcode or define defaults
 * @param {object} chart object
 * @param {object} fill am4core color passed from amcharts
 * @param {object} target from template adapter, source od data item
 * @returns {object} am4core color
 */
bocAmchart4.calculateMapColors = function (chart, fill, target) {
    let markerCount = 2;
    let index, legendLabelMin, legendLabelMax, allColors;
    let legendBuckets = bocAmchart4.vars[chart.bocSettings.id].legendBuckets;

    // Override markerCount with user-defined shortcode values
    if (chart.bocSettings.args.hasOwnProperty('markercount')) {
        markerCount = parseFloat(chart.bocSettings.args.markercount);
    }
    // Override maxColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('maxcolorvalue')) {
        bocAmchart4.vars[chart.bocSettings.id].maxValue = parseFloat(chart.bocSettings.args.maxcolorvalue);
    }
    // Override minColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('mincolorvalue')) {
        bocAmchart4.vars[chart.bocSettings.id].minValue = parseFloat(chart.bocSettings.args.mincolorvalue);
    }

    // Set min and max values either from dataset defaults or user-defined values
    let minValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].minValue);
    let maxValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].maxValue);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these min/max:",
            "Min value: " + minValue,
            "Max value: " + maxValue,
            "Marker count:" + markerCount
        );
    }

    let mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;
    bocAmchart4.vars[chart.bocSettings.id].locale = (chartLanguage === "fr") ? 'fr-CA' : 'en-CA';
    let rect;

    // This condition is to check if legend has already been set up
    if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty("maxLabel")) {
        bocAmchart4.vars[chart.bocSettings.id].maxLabel.text = bocAmchart4.locale(chart, maxValue);
    } else {
        // Create heat legend container and size
        let heatLegend = chart.createChild(am4core.Container);
        heatLegend.width = 15;
        heatLegend.height = 400;
        heatLegend.align = "right";
        heatLegend.valign = "middle";
        heatLegend.layout = "vertical";

        // Array to hold the rectangles for each bucket of values in the legend
        rect = [];

        for (index = 0; index < markerCount; index++) {
            // Create new rectangle for each bucket
            rect[index] = heatLegend.createChild(am4core.Rectangle);
            rect[index].width = am4core.percent(100);
            rect[index].height = am4core.percent(100 / markerCount);
            rect[index].strokeWidth = 0;
            if (index === 0) {
                // Assign last colour in mainColours to the last bucket in the legend
                fill = mainColors[mainColors.length - 1];
            } else if (index === markerCount - 1) {
                // Assign first colour in mainColours to the first bucket in the legend
                fill = mainColors[0];
            } else {
                // Find the next gradient colour
                let relValueLegend = ((markerCount - 1) - index) / (markerCount - 1);
                let arrayRangeLegend = relValueLegend * (mainColors.length - 1);
                let baseIdxLegend = Math.floor(arrayRangeLegend);
                let gradientRangeLegend = arrayRangeLegend - baseIdxLegend;

                fill = am4core.colors.interpolate(
                    mainColors[baseIdxLegend].rgb,
                    mainColors[baseIdxLegend + 1].rgb,
                    gradientRangeLegend
                );
            }
            // Add colour to allColors variable and to rectangle
            bocAmchart4.vars[chart.bocSettings.id].allColors[markerCount - index - 1] = {
                'color': fill
            };
            rect[index].fill = fill;
        }

        // Create label container for maximum bucket
        legendLabelMax = chart.createChild(am4core.Label);
        legendLabelMax.text = bocAmchart4.locale(chart, maxValue);
        legendLabelMax.align = "right";
        legendLabelMax.valign = "top";
        legendLabelMax.marginTop = am4core.percent(5);
        legendLabelMax.fontSize = "0.875em";
        bocAmchart4.vars[chart.bocSettings.id].maxLabel = legendLabelMax;
    }

    if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty("minLabel")) {
        bocAmchart4.vars[chart.bocSettings.id].minLabel.text = bocAmchart4.locale(chart, minValue);
    } else {
        // Create label container for minimum bucket
        legendLabelMin = chart.createChild(am4core.Label);
        legendLabelMin.text = bocAmchart4.locale(chart, minValue);
        legendLabelMin.align = "right";
        legendLabelMin.valign = "bottom";
        legendLabelMin.marginBottom = am4core.percent(5);
        legendLabelMin.fontSize = "0.875rem";
        bocAmchart4.vars[chart.bocSettings.id].minLabel = legendLabelMin;
    }

    allColors = bocAmchart4.vars[chart.bocSettings.id].allColors;
    for (let markerIndex = 0; markerIndex < markerCount; markerIndex++) {
        // Assign low and high values to each colour
        allColors[markerIndex].low = legendBuckets[markerIndex];
        allColors[markerIndex].high = legendBuckets[markerIndex + 1];
    }

    // Minimum and maximum label containers in the legend
    legendLabelMin = bocAmchart4.vars[chart.bocSettings.id].minLabel;
    legendLabelMax = bocAmchart4.vars[chart.bocSettings.id].maxLabel;

    // Sets up tooltips/labels based on whether min overflow bucket exists
    if (allColors[0].low === false) {
        // Add correct number of decimals to the value, then turn into a number in order to apply the number formatting
        legendLabelMin.text = '< ' + bocAmchart4.locale(chart, allColors[0].high);
    } else {
        // minOverflowBucket does not exist
        legendLabelMin.text = "< " + bocAmchart4.locale(chart, allColors[0].high) + "\n"
            + bocAmchart4.locale(chart, allColors[0].low) + " ≥";
        // Adjust margin so label doesn't overlap with the heat legend
        legendLabelMin.marginBottom = 0;
    }

    // Sets up tooltips/labels based on whether max overflow bucket exists
    if (allColors[allColors.length - 1].high === false) {
        // maxOverflowBucket exists
        legendLabelMax.text = '≥ ' + bocAmchart4.locale(chart, allColors[allColors.length - 1].low);
    } else {
        // maxOverflowBucket does not exist
        legendLabelMax.text = "≤ " + bocAmchart4.locale(chart, allColors[allColors.length - 1].high) + "\n"
            + bocAmchart4.locale(chart, allColors[allColors.length - 1].low) + " ≥";
        // Adjust margin so label doesn't overlap with the heat legend
        legendLabelMax.marginTop = 15;
    }

    bocAmchart4.vars[chart.bocSettings.id].minLabel = legendLabelMin;
    bocAmchart4.vars[chart.bocSettings.id].maxLabel = legendLabelMax;

    // Set tooltip text for all rectangles with less than/greater than buckets
    if (typeof (rect) !== "undefined") {
        for (index = 1; index < (markerCount - 1); index++) {
            rect[index].tooltipText = "< " + bocAmchart4.locale(chart, allColors[markerCount - index - 1].high) + "\n"
                + bocAmchart4.locale(chart, allColors[markerCount - index - 1].low) + " ≥";
        }
        rect[0].tooltipText = legendLabelMax.text;
        rect[index].tooltipText = legendLabelMin.text;
    }

    // Assign a colour to each datapoint
    if (!isNaN(target.dataItem.value)) {
        let value = target.dataItem.value;
        let allColorsMap = bocAmchart4.vars[chart.bocSettings.id].allColors;

        let minOverflowBucket = allColorsMap[0].low;
        let maxOverflowBucket = allColorsMap[allColorsMap.length - 1].high;

        fill = bocAmchart4.getFillColor(value, allColorsMap, markerCount, minOverflowBucket, maxOverflowBucket);
    }
    return fill;
};

/**
 * Determines the fill color based on the value and color buckets.
 *
 * @param {number} value - The value for which to determine the fill color.
 * @param {Array<Object>} allColorsMap - Array of color buckets where each object contains `low`, `high`, and `color` properties.
 * @param {number} markerCount - The total number of color buckets in `allColorsMap`.
 * @param {boolean|number} minOverflowBucket - The lower boundary for overflow buckets. If `false`, no minimum overflow bucket is used.
 * @param {boolean|number} maxOverflowBucket - The upper boundary for overflow buckets. If `false`, no maximum overflow bucket is used.
 *
 * @returns {string} The color to be used for the given value. This is the color from the color buckets that matches the value's range.
 */
bocAmchart4.getFillColor = function (value, allColorsMap, markerCount, minOverflowBucket, maxOverflowBucket) {
    let fill;

    if (minOverflowBucket === false && maxOverflowBucket === false) {
        // There are min and max overflow buckets (< minValue and >= maxValue)
        if (value < allColorsMap[0].high) {
            fill = allColorsMap[0].color;
        } else if (value >= allColorsMap[allColorsMap.length - 1].low) {
            fill = allColorsMap[markerCount - 1].color;
        } else {
            for (let index = 0; index < markerCount; index++) {
                if ((value >= allColorsMap[index].low) && (value < allColorsMap[index].high)) {
                    fill = allColorsMap[index].color;
                    break;
                }
            }
        }
    } else if (minOverflowBucket === false) {
        // There is a minimum overflow bucket but no max (only < minValue)
        if (value < allColorsMap[0].high) {
            fill = allColorsMap[0].color;
        } else if (value >= allColorsMap[allColorsMap.length - 1].high) {
            fill = allColorsMap[markerCount - 1].color;
        } else {
            for (let index = 0; index < markerCount; index++) {
                if ((value >= allColorsMap[index].low) && (value < allColorsMap[index].high)) {
                    fill = allColorsMap[index].color;
                    break;
                }
            }
        }
    } else if (maxOverflowBucket === false) {
        // There is a max overflow bucket but no max (only >= maxValue)
        if (value < allColorsMap[0].low) {
            fill = allColorsMap[0].color;
        } else if (value >= allColorsMap[allColorsMap.length - 1].high) {
            fill = allColorsMap[markerCount - 1].color;
        } else {
            for (let index = 0; index < markerCount; index++) {
                if ((value >= allColorsMap[index].low) && (value < allColorsMap[index].high)) {
                    fill = allColorsMap[index].color;
                    break;
                }
            }
        }
    } else {
        // Assign color to specified buckets
        for (let index = 0; index < markerCount; index++) {
            if (index !== (markerCount - 1)) {
                if ((value >= allColorsMap[index].low) && (value < allColorsMap[index].high)) {
                    fill = allColorsMap[index].color;
                    break;
                }
            } else {
                // Accounts for value equalling maxValue
                if ((value >= allColorsMap[index].low) && (value <= allColorsMap[index].high)) {
                    fill = allColorsMap[index].color;
                    break;
                }
            }
        }
    }
    return fill;
};


/**
 * Set up the default Amcharts4 map legend with either default/user-defined colours
 * @param {object} chart object
 * @param {object} series target series
 * @param {object} polygonTemplate map polygon template
 * @returns {void}
 */
bocAmchart4.defaultMapLegend = function (chart, series, polygonTemplate) {
    let mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these colors:",
            mainColors
        );
    }

    // Set up heat rules for series with either default or user-defined colours
    series.heatRules.push({
        target: polygonTemplate,
        property: "fill",
        min: am4core.color(mainColors[0]),
        max: am4core.color(mainColors[mainColors.length - 1])
    });

    // Create heat legend container and size
    let heatLegendContainer = chart.createChild(am4core.Container);
    heatLegendContainer.width = 15;
    heatLegendContainer.height = 400;
    heatLegendContainer.align = "right";
    heatLegendContainer.valign = "middle";
    heatLegendContainer.layout = "vertical";

    // Create Amcharts heat legend
    let heatLegend = heatLegendContainer.createChild(am4maps.HeatLegend);
    heatLegend.series = series;
    heatLegend.width = am4core.percent(100);
    heatLegend.height = am4core.percent(100);
    heatLegend.orientation = "vertical";
    heatLegend.align = "center";
    heatLegend.valign = "middle";

    // Adjust labels positioning
    heatLegend.valueAxis.renderer.opposite = true;
    heatLegend.valueAxis.renderer.labels.template.fontSize = "0.563em";
    heatLegend.valueAxis.renderer.minGridDistance = 30;
    // This padding is for 5 digit labels, will need to adjust smaller sized labels
    heatLegend.valueAxis.renderer.labels.template.paddingRight = 25;

    // Adjust tooltip position a little to the left, so it's positioned better against the legend
    heatLegend.valueAxis.tooltip.adapter.add("x", function (position) {
        return position - 20;
    });

    // Heat legend behaviour
    series.mapPolygons.template.events.on("over", (event) => {
        handleHover(event.target);
    });
    series.mapPolygons.template.events.on("hit", (event) => {
        handleHover(event.target);
    });

    /**
     * Show legend tooltip when hovering over a datapoint
     * @param {object} polygon object
     * @returns {void}
     */
    function handleHover(polygon) {
        if (!isNaN(polygon.dataItem.value)) {
            heatLegend.valueAxis.showTooltipAt(polygon.dataItem.value);
        } else {
            heatLegend.valueAxis.hideTooltip();
        }
    }

    series.mapPolygons.template.events.on("out", () => {
        heatLegend.valueAxis.hideTooltip();
    });
};

